import React, {Component} from 'react';
import {gpn} from "../GPN"
import ModalLoading from "../sections/ModalLoading";
import noItemImage from "../assets/images/no-item.png";
import req from "../req";
import config from "../config";
import Button from "../sections/MUI/Button";
import Modal from "../sections/MUI/Modal";
import Field from "../sections/MUI/Field";
import {toast} from "react-toastify";
import {Link} from "react-router";

class Facilities extends Component {

    state = {
        facilities: null,
        form: [],
        userForm: [],
        services: [],

        price: "",
        description: "",

        modalLoading: true,
        modalSubmit: false,

        deleteIndex: -1
    };

    componentDidMount() {
        this.props.setTitle("درخواست تسهیلات");
        this.getServices();
    }

    getServices() {
        req.getRequest(`${config.api}/user/services`)
            .then(r => {
                this.setState({
                    services: r.services
                });
                this.getFacilities();
            })
            .catch(err => {
                config.handleError(err);
                this.getFacilities();
            });
    }

    getFacilities() {
        req.getRequest(`${config.api}/user/facilities`)
            .then(r => {
                let userForm = r.userForm ? r.userForm : [];
                if (userForm.length === 0) {
                    r.form.map((f, i) => {
                        userForm.push({
                            name: "f" + i,
                            value: "",
                            label: f
                        })
                    })
                }
                this.setState({
                    facilities: r.facilities,
                    form: r.form,
                    userForm,
                    modalLoading: false
                });
            })
            .catch(err => {
                config.handleError(err);
                this.setState({modalLoading: false});
            });
    }

    submitPrice() {
        let {price, description} = this.state;
        description = description.toString().trim();

        if (price.length > 0) {
            this.setState({
                modalLoading: true
            });
            let params = {
                priceRequest: price,
                descriptionRequest: description
            }
            req.postRequest(`${config.api}/user/facilities/request/submit`, params)
                .then(r => {
                    toast.success("درخواست شما با موفقیت ثبت شد. از ارسال مکرر درخواست پرهیز کنید!");
                    this.setState({
                        modalLoading: false,
                        modalSubmit: false,
                        price: "",
                        description: ""
                    });
                })
                .catch(err => {
                    console.error(err);
                    toast.error("خطایی رخ داده است! زمانی دیگر مجدداً تلاش کنید.")
                    this.setState({
                        modalLoading: false,
                        modalSubmit: false,
                        price: "",
                        description: ""
                    });
                });
        }
    }

    handleInputFormChange(index, value) {
        let {userForm} = this.state;
        userForm[index].value = value;
        this.setState({userForm});
    }

    sum() {
        let {facilities, services} = this.state;
        let s = 0;
        facilities.map(f => {
            s = s + Number(f.registerPrice.toString().replace(/,/g, "").trim())
        });

        services.map(service => {
            s = s + Number(service.price.toString().replace(/,/g, "").trim())
        });

        return s;
    }


    submitOrder() {
        let {userForm, facilities, services} = this.state;
        userForm = userForm ? userForm : [];
        let finalUserForm = [];

        let error = "";

        userForm.map(uf => {
            let {value, label} = uf;
            finalUserForm.push({
                title: label,
                value: value.toString().trim()
            });
            value = value.toString().trim();
            if (value === "" && error === "") {
                error = `${label} وارد نشده!`;
            }
        });

        if (error === "") {
            this.setState({modalLoading: true});
            req.postRequest(`${config.api}/user/order/create`, {
                form: finalUserForm,
                facilities,
                services
            })
                .then(r => {
                    const {url} = r;
                    try {
                        document.location.href = url;
                    } catch (err) {
                    }
                    this.setState({modalLoading: false});
                })
                .catch(err => {
                    config.handleError(err);
                    this.setState({modalLoading: false});
                });
        } else {
            toast.error(error);
        }


    }

    deleteFacilitiesItem() {
        let {deleteIndex} = this.state;
        this.setState({
            deleteIndex: -1,
            modalLoading: true
        });
        req.deleteRequest(`${config.api}/user/facilities?index=${deleteIndex}`)
            .then(r => {
                toast.success("با موفقیت حذف شد!");
                this.setState({
                    modalLoading: false
                });
                this.getFacilities();
            })
            .catch(err => {
                config.handleError(err);
                this.setState({modalLoading: false});
            });
    }

    render() {
        let {facilities, services, userForm, price, description, modalLoading, modalSubmit, deleteIndex} = this.state;


        return (
            <div className="facilities">
                <ModalLoading loading={modalLoading}/>
                {
                    deleteIndex !== -1 ?
                        <Modal title={"حذف طرح " + facilities[deleteIndex].title.replace("طرح", "").trim()}
                               onCloseClick={() => this.setState({deleteIndex: -1})}
                               display={deleteIndex !== -1}>
                            <p style={{textAlign: "center"}}>آیا از حذف
                                طرح {facilities[deleteIndex].title.replace("طرح", "").trim()}&nbsp;به
                                مبلغ:&nbsp;{config.priceFormatter(facilities[deleteIndex].price)}&nbsp;تومان&nbsp;اطمینان
                                دارید؟</p>

                            <br/><br/>
                            <Button backgroundColor="#d00000" icon="check"
                                    onClick={() => this.deleteFacilitiesItem()}>بله، حذف شود</Button>

                            <Button backgroundColor="#959595"
                                    icon="close"
                                    onClick={() => this.setState({deleteIndex: -1})}>خیر، حذف نشود</Button>
                        </Modal>
                        : null
                }
                <Modal display={modalSubmit}
                       title="ثبت درخواست"
                       onCloseClick={() => this.setState({modalSubmit: false})}>
                    <Field typePrice
                           style={{direction: "ltr"}}
                           name="price"
                           maxLength={14}
                           label="مبلغ درخواستی (به تومان)"
                           value={price}
                           onChange={(name, value) => this.setState({[name]: value})}/>

                    <Field name="description"
                           value={description}
                           type="textarea"
                           row={3}
                           maxLength={2000}
                           onChange={(name, value) => this.setState({[name]: value})}
                           label="توضیحات و خدمات مورد نیاز برای درخواست شما (اختیاری)"/>
                    <Button submit={false} icon="check" onClick={() => this.submitPrice()}>ثبت درخواست</Button>
                </Modal>
                {
                    !modalLoading && facilities ?
                        facilities?.length > 0 ?
                            <>
                                <h2>طرح های پیشنهادی برای شما</h2>
                                <p className="nemikham-hint">
                                    <div>1- طرح پشنهادی...</div>
                                    <div>2- پس از ثبت و انتخاب طرح امکان ویرایش وجود ندارد و مستلزم پرداخت هزینه خواهد
                                        شد!
                                    </div>
                                    <div>3- در انتخاب نوع طرح دقت فرمایید و متن توافق و قراداد را با دقت مطالعه
                                        فرمایید.
                                    </div>
                                </p>
                                <div className="facilities-list">
                                    {
                                        facilities.map((f, i) =>
                                            <article key={"f" + i}>
                                                <p className="title"><span>{i + 1}-</span><span>{f.title}</span></p>
                                                <p className="price">
                                                    <span>سقف تسهیلات:</span><span>{config.priceFormatter(f.price)}&nbsp;تومان</span>
                                                </p>
                                                <p className="register-price">
                                                    <span>هزینه ثبت نام:</span><span>{config.priceFormatter(f.registerPrice)}&nbsp;تومان</span>
                                                </p>
                                                <div className="nemikham">
                                                    <span onClick={() => this.setState({deleteIndex: i})}>حذف</span>
                                                </div>
                                            </article>
                                        )
                                    }
                                </div>
                                {
                                    services.length > 0 ?
                                        <div className="service-list">
                                            <h2>خدمات ثبت شده برای شما</h2>

                                            {services.map((s, i) =>
                                                <article key={"service" + i}>
                                                    <p className="title"><span>{i + 1}-</span><span>{s.title}</span></p>
                                                    <p className="price">
                                                        <span>نرخ:</span><span>{config.priceFormatter(s.price)}</span>
                                                    </p>
                                                </article>
                                            )
                                            }


                                        </div>
                                        : null
                                }

                                <div className="form">
                                    {
                                        userForm.map((f, i) =>
                                            <Field
                                                key={f.name}
                                                name={f.name}
                                                value={f.value}
                                                label={f.label}
                                                onChange={(name, value) => this.handleInputFormChange(i, value)}/>
                                        )
                                    }
                                </div>

                                <br/><br/>

                                <div className="sum">
                                    <span>مبلغ قابل پرداخت:</span><span>{config.priceFormatter(this.sum())}&nbsp;تومان</span>
                                </div>
                                <br/>

                                <Button backgroundColor="#008000" icon="check"
                                        onClick={() => this.submitOrder()}>پرداخت
                                    و ثبت نهایی</Button>
                            </>
                            :
                            <div className="no-item">
                                <div className="image">
                                    <img src={noItemImage} alt=""
                                         draggable={false}/>
                                </div>
                                <p className="title">درخواست ثبت شده ای وجود ندارد!</p>

                                <div className="nav">
                                    <div className="row justify-content-center">
                                        <Link to="/orders">لیست سفارشات</Link>
                                        <Link to="/payments">لیست پرداخت ها</Link>
                                    </div>
                                </div>

                                <Button submit={false} icon="check"
                                        onClick={() => this.setState({modalSubmit: true})}>ثبت
                                    درخواست</Button>
                            </div>
                        : null
                }
            </div>
        );
    }
}

export default gpn(Facilities);